import PropTypes from 'prop-types'
import React from 'react'
import { Link } from 'react-router-dom'

import filterParamsConfig from '../../../../common/constants/filterParamsConfig'
import CancelIcon from '../../icons/cancel'

/**
 * A function to render the selected filter link
 * @param  {String} the type of the param, can be category, tags
 * @param  {String} the displayName of the filter
 * @param  {String} the link to the filter
 * @param  {Number} the index of the current option
 * @return {HTML} HTML for the option
 */
const FilterItem = ({ paramType, displayName, link, index }) => {
  const Icon = filterParamsConfig[paramType].icon
  // only show icon for the first item
  return (
    <li key={index}>
      <div className="search-facet-actives__facet">
        <span className="search-facet-actives__icon">
          {index === 0 ? <Icon /> : null}
        </span>
        <span className="search-facet-actives__text">{displayName}</span>
        <Link to={link} className="search-facet-actives__glyph-cancel">
          <CancelIcon />
        </Link>
      </div>
    </li>
  )
}

FilterItem.propTypes = {
  paramType: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired
}

export default FilterItem



// WEBPACK FOOTER //
// ./client/components/filters/selectedFilters/filterItem.js